import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type Props = {
  vendorDisplayName: string;
  cartVendor: string;
  displaySourceSite?: string;
  cartStore?: string;
};

/**
 * This component renders: "This is a/an <vendor> list."
 */
export const VendorTextBlock = ({
  vendorDisplayName,
  displaySourceSite,
  cartStore,
  cartVendor,
}: Props) => {
  const [sourceSite, setSourceSite] = useState<string>('');
  const [displayName, setDisplayName] = useState(vendorDisplayName || '');

  const { t, i18n } = useTranslation();

  const i18nLang = i18n.resolvedLanguage
    ? i18n.resolvedLanguage.toLowerCase()
    : i18n.language.toLowerCase();

  const isVowel = displayName?.match(/^[aeiou]/i);

  useEffect(() => {
    if (
      cartVendor === 'amazon' &&
      cartStore &&
      (cartStore.endsWith('localmarket') || cartStore?.endsWith('fresh'))
    ) {
      if (cartStore.toLowerCase().includes('amazon.com/cart/localmarket')) {
        setDisplayName(`${vendorDisplayName} Whole Foods`);
      } else {
        setDisplayName(`${vendorDisplayName} Fresh`);
      }
    }
  }, [cartStore, cartVendor, vendorDisplayName]);

  useEffect(() => {
    if (displaySourceSite) {
      if (!displaySourceSite.startsWith('http')) {
        setSourceSite(`https://${displaySourceSite}`);
      } else {
        setSourceSite(displaySourceSite);
      }
    }
  }, [displaySourceSite]);

  return (
    <Trans
      i18nKey={
        i18nLang === 'en' && isVowel
          ? t('common.this_is_an_vendor_list')
          : t('common.this_is_a_vendor_list')
      }
      context={sourceSite ? 'sourceSite' : 'noSourceSite'}
      values={{
        vendorDisplayName,
      }}
      components={{
        1: sourceSite ? <SourceSite sourceSite={sourceSite} /> : <></>,
      }}
    />
  );
};

const SourceSite = ({ sourceSite }: { sourceSite: string | undefined }) => {
  if (!sourceSite) return null;

  return (
    <Link
      to={`/u/${encodeURIComponent(sourceSite)}/web`}
      target='_blank'
      rel='noopener noreferrer'
      className='text-100 break-all font-bold text-grassGreen underline transition-all hover:text-grassGreen/70'
    >
      {sourceSite}
      <OpenInNewOutlinedIcon
        className='ml-0.5 fill-grassGreen hover:fill-grassGreen/70'
        style={{ fontSize: 20 }}
      />
    </Link>
  );
};
